import React from 'react';
import { useTranslation } from 'react-i18next';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import { UseCameraIcon } from '../../../../../components/buttons/IconButtons';
import SummaryDetailsCard from './SubComponents/SummaryDetailsCard';
import SummaryOtherDetailsCard from './SubComponents/SummaryOtherDetailsCard';
import SummaryEmployeeContractCard from './SubComponents/SummaryEmployeeContractCard';
import SummaryAccessRightsCard from './SubComponents/SummaryAccessRightsCard';
import SummaryFingerprintCard from './SubComponents/SummaryFingerprintCard';
import SummaryCardsInfoCard from './SubComponents/SummaryCardsInfoCard';

const Step8Summary = ({
    userData,
    extraData,
    headersList,
    employeeData,
    employeeRoles,
    employeeWorkStations,
    employeeDepartments,
    workShiftsList,
    customizedList,
    extraDataEnabled,
    photoPicker,
    isPilgrimsValidation,
    cardsList,
    mergedFingerprints,
}) => {
    const { t } = useTranslation();
    return (
        <div className='row mt-4'>
            <div className={"row mb-4 px-0"}>
                <div className={`background-general-00 border-radius-8px border-full-shades-300 p-0`}>
                    <div className={'p-3 d-flex align-items-center'}>
                        <div className={'mr-2'}>
                            <UseCameraIcon width={24} height={24} />
                        </div>
                        <p className={'font-color-general-950 ibl-font-w-600 fs-14-to-13 '}>{t('photography')}</p>
                    </div>
                    <div className={"border-bottom-shades-300 w-100"}/>
                    <div className={"p-3"}>
                        <PhotoPickerSummary photoPicker={photoPicker} classWith={'w-400px'} />
                    </div>
                </div>
            </div>

            <div className={"row mb-4 px-0"}>
                <SummaryDetailsCard userData={userData} />
            </div>

            {extraDataEnabled && (
                <div className={"row mb-4 px-0"}>
                    <SummaryOtherDetailsCard extraData={extraData} headersList={headersList} />
                </div>
            )}

            <div className={"row mb-4 px-0"}>
                <SummaryEmployeeContractCard
                    employeeData={employeeData}
                    employeeRoles={employeeRoles}
                    employeeWorkStations={employeeWorkStations}
                    employeeDepartments={employeeDepartments}
                    isPilgrimsValidation={isPilgrimsValidation}
                />
            </div>
            <div className={"row mb-4 px-0"}>
                <SummaryAccessRightsCard
                    workShiftsList={workShiftsList}
                    customizedList={customizedList}
                />
            </div>

            <div className={"row mb-4 px-0"}>
                <SummaryFingerprintCard mergedFingerprints={mergedFingerprints} />
            </div>

            <div className={"row mb-4 px-0"}>
                <SummaryCardsInfoCard cardsList={cardsList} />
            </div>
        </div>
    );
};

export default Step8Summary;
